<template>
  <v-page-content>
    <education editMode></education>
  </v-page-content>
</template>

<script>

import Education from '@/components/content/education/index.vue'

export default {
  name: 'EditTrainingsPage',
  components: {
    Education
  }
}
</script>

<style scoped>

</style>
